/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  ConfigProvider,
  DatePicker,
  Input,
  Spin,
  message,
  Modal,
  Pagination,
} from 'antd';
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import esES from 'antd/es/locale/es_ES';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import store from 'store/store';
import ErrorBoundary from 'components/ErrorBoundary';
import { DEV } from 'utils/env';
import App from 'App';
import 'utils/setup-moment';

const validateMessages = {
  required: 'El campo es requerido',
  types: {
    email: 'Ingrese un correo electrónico válido',
    integer: 'Ingrese un número enteró',
    url: 'Ingrese una URL válida',
    float: 'Ingrese un decimal válido',
  },
};

const autoComplete = DEV ? 'on' : 'off';
const persistor = persistStore(store);

Pagination.defaultProps = {
  ...Pagination.defaultProps,
  locale: {
    jump_to: 'Ir a página',
    page: '',
  },
};
Modal.defaultProps = {
  ...Modal.defaultProps,
  closeIcon: <CloseCircleOutlined />,
};

Spin.defaultProps = {
  indicator: <LoadingOutlined />,
  tip: 'Cargando',
};

Input.defaultProps = {
  allowClear: true,
};

Input.TextArea.defaultProps = {
  allowClear: true,
};

DatePicker.defaultProps = {
  format: 'DD-MM-YYYY',
  locale: esES,
  placeholder: '',
};

DatePicker.RangePicker.defaultProps = {
  format: 'DD-MM-YYYY',
  locale: esES,
  placeholder: '',
};

message.config({
  top: 100,
  duration: 2.5,
  maxCount: 1,
});

const { error } = console;
// eslint-disable-next-line no-console
console.error = (...args) => {
  if (/defaultProps|deprecated|(will be removed in next major version)/i.test(args[0])) return;
  if (/fillRule/.test(args[2])) return;
  error(...args);
};

// eslint-disable-next-line no-console
console.warn = () => null;

document.title = process.env.REACT_APP_META_TITLE;

ReactDOM.createRoot(document.getElementById('root')).render(
  <ConfigProvider form={{ validateMessages }} input={{ autoComplete }} locale={esES}>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </ConfigProvider>,
);
